export const KEY_ONLY = Symbol();

// TODO support array params with same key names
export function parseQueryArray(query) {
  return query.reduce((qps, qp) => {
    if (qp.length) {
      if (typeof qp === 'string') {
        qp = qp.split('=');
      }
      qps[qp[0]] = qp.length < 2 ? KEY_ONLY : qp[1];
    }
    return qps;
  }, {});
}

export function parseQueryString(query) {
  return parseQueryArray(
    (('' + query).split('#')[0].split('?')[1] || []).split('&'),
  );
}

export function parseQueryParams(qps) {
  return !qps
    ? []
    : Array.isArray(qps)
      ? parseQueryArray(qps)
      : typeof qps === 'string'
        ? parseQueryString(qps)
        : typeof qps === 'object'
          ? qps
          : [];
}

export function mergeParsedQueryParams(...qps) {
  return qps.reduce((qps, qp) => Object.assign(qps, qp), {});
}

export function mergeQueryParams(...qps) {
  return mergeParsedQueryParams(...qps.map(parseQueryParams));
}

// These are characters that encodeURIComponent encodes, but shouldn't for query part of URL
export const queryPartCharacterWhitelist = ';,/?:@';
export const matchQueryPartCharacterWhitelist = new RegExp(
  `([${queryPartCharacterWhitelist}]+)`,
);

export function sanitizeQueryPart(query) {
  return ('' + query)
    .split(matchQueryPartCharacterWhitelist)
    .map((v, i) => (i % 2 ? v : encodeURIComponent(v)))
    .join('');
}

export function stringifyParsedQueryParams(qps) {
  return Object.entries(qps)
    .reduce((query, [key, value]) => {
      if (value !== undefined) {
        key = sanitizeQueryPart(key);
        query.push(
          value === KEY_ONLY ? key : `${key}=${sanitizeQueryPart(value)}`,
        );
      }
      return query;
    }, [])
    .join('&');
}

export function joinPaths(paths) {
  let result = paths?.[0] || '';
  for (let i = 1; i < paths?.length; ++i) {
    const path = paths[i];
    if (!path || path === '/') {
      continue;
    }
    const hasLeftSlash = result.charAt(result.length - 1) === '/';
    const hasRightSlash = paths[i].charAt(0) === '/';
    result +=
      (!hasLeftSlash && !hasRightSlash ? '/' : '') +
      (hasLeftSlash && hasRightSlash ? path.substring(1) : path);
  }
  return result;
}

const matchProtocolEnding = /(:\/{0,2})?$/;
export function joinUrl(host, path, protocol = 'http') {
  return joinPaths([protocol.replace(matchProtocolEnding, '://'), host, path]);
}

export const matchBreakChars = /[/?&%]/g;

export function urlBreak(url) {
  return url ? String(url).replace(matchBreakChars, `<wbr>$&`) : '';
}
